var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"space-x-1"},[(_vm.props.required)?_c('span',{staticClass:"error"},[_vm._v("*")]):_vm._e(),_c('span',{staticClass:"bx--label"},[_vm._v(_vm._s(_vm.props.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }